import { useEffect, useState } from "react";
import { useTranslation } from "../contexts/TranslationContext";
import { fetchHomepageContent } from "../APIClient/apiClient";

export function useHomePageContent() {
  const { currentLanguage } = useTranslation();
  const [content, setContent] = useState({
    title: "",
    description: "",
    metaTitle: "",
    cards: [],
    logoStrips: [],
  });

  useEffect(() => {
    let isActive = true;

    setContent({
      title: "",
      description: "",
      metaTitle: "",
      cards: [],
      logoStrips: [],
    });

    fetchHomepageContent(currentLanguage).then((data) => {
      if (!isActive) {
        return;
      }

      if (data) {
        setContent({
          title: data.title || "",
          description: data.description || "",
          metaTitle: data.metaTitle || "",
          cards: Array.isArray(data.cards) ? data.cards : [],
          logoStrips: Array.isArray(data.logoStrips) ? data.logoStrips : [],
        });
      }
    });

    return () => {
      isActive = false;
    };
  }, [currentLanguage]);

  return content;
}
